// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file patients/update_patient.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PatientMetadata } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.UpdatePatientRequest
 */
export class UpdatePatientRequest extends Message<UpdatePatientRequest> {
  /**
   * Full name of the patient
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Phone number of the patient
   *
   * @generated from field: string phone = 2;
   */
  phone = "";

  /**
   * Government-issued identifier (e.g., national ID, passport)
   *
   * @generated from field: string govt_identifier = 3;
   */
  govtIdentifier = "";

  /**
   * Additional metadata about the patient
   *
   * @generated from field: com.neulink.pharmacy.PatientMetadata metadata = 4;
   */
  metadata?: PatientMetadata;

  /**
   * Unique identifier for the patient
   *
   * @generated from field: string patient_id = 5;
   */
  patientId = "";

  constructor(data?: PartialMessage<UpdatePatientRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdatePatientRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "govt_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metadata", kind: "message", T: PatientMetadata },
    { no: 5, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePatientRequest {
    return new UpdatePatientRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePatientRequest {
    return new UpdatePatientRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePatientRequest {
    return new UpdatePatientRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePatientRequest | PlainMessage<UpdatePatientRequest> | undefined, b: UpdatePatientRequest | PlainMessage<UpdatePatientRequest> | undefined): boolean {
    return proto3.util.equals(UpdatePatientRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UpdatePatientResponse
 */
export class UpdatePatientResponse extends Message<UpdatePatientResponse> {
  /**
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  constructor(data?: PartialMessage<UpdatePatientResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpdatePatientResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdatePatientResponse {
    return new UpdatePatientResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdatePatientResponse {
    return new UpdatePatientResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdatePatientResponse {
    return new UpdatePatientResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdatePatientResponse | PlainMessage<UpdatePatientResponse> | undefined, b: UpdatePatientResponse | PlainMessage<UpdatePatientResponse> | undefined): boolean {
    return proto3.util.equals(UpdatePatientResponse, a, b);
  }
}

